<template lang="pug">
  div
    .placeholder(v-if='loading')
    .content.past(v-if='!loading')
      .grid
        .col-4_xs-12.titles
          router-link(:to={path: '/exhibitions'})
            h2
              | exhibitions
          h4.status
            | past
        .col-8.years(data-push-left="off-0_xs-4")
          router-link(
            v-for="year in years",
            :to="{name: 'exhibitions-overview', params: {year: year.title}}",
            :key="year.title"
          )
            h2
              | {{ year.title }}
</template>

<script>
import DataMixin from '@/mixins/DataMixin'
import ComponentMixin from '@/mixins/ComponentMixin'

export default {
  name: 'exhibitions-past',
  mixins: [DataMixin, ComponentMixin],

  created () {
    this.requestData('exhibitions', 'exhibitions')
    window.scrollTo(0, 0)
  },

  methods: {
  },

  computed: {
    years: function () {
      return this.loadedData.exhibitions.years
    }
  }
}
</script>

<style lang="sass">
  @import '../styles/main'
  .content
    .status
      color: #FD0000
      font-size: 2rem
    .years
      margin-top: 14rem
      @include respond-to(xs)
        margin-top: 0
</style>



// WEBPACK FOOTER //
// ExhibitionsPast.vue?9e8f4412